import styled from '@emotion/styled';
import { color, space, fontSize, lineHeight, textAlign, fontWeight, } from 'styled-system';
export var Text = styled.div(fontSize, lineHeight, textAlign, fontWeight, color, space);
Text.defaultProps = {
    color: 'text',
    fontSize: 3,
    lineHeight: 3,
};
export var SmallText = styled.div(fontSize, lineHeight, textAlign, fontWeight, color, space);
SmallText.defaultProps = {
    color: 'text',
    fontSize: 2,
    lineHeight: 1,
};
export var BigHeading = styled.div(fontSize, lineHeight, textAlign, fontWeight, color, space);
BigHeading.defaultProps = {
    color: 'text',
    textAlign: 'center',
    fontSize: [6, null, 7],
    lineHeight: [4, null, 5],
    fontWeight: 'bold',
};
export var Heading = styled.div(fontSize, lineHeight, textAlign, fontWeight, color, space);
Heading.defaultProps = {
    color: 'text',
    fontSize: [4, null, 6],
    lineHeight: [3, null, 4],
    fontWeight: 'bold',
};
export var SmallHeading = styled.div(fontSize, lineHeight, textAlign, fontWeight, color, space);
SmallHeading.defaultProps = {
    color: 'text',
    fontSize: [3, null, 4],
    lineHeight: 3,
    fontWeight: 'bold',
};
